module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Up-2-782646dd0d6be9b9a11861ec2e3cfcd8.svg";